export const BEFORE_PARAM_NAME = 'all-locations-before';
export const AFTER_PARAM_NAME = 'all-locations-after';
